/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum PolicySubClassification {
    Access = 'Access',
    Anomaly = 'Anomaly',
    Application = 'Application',
    Application_Integration = 'Application_Integration',
    Availability = 'Availability',
    Backup = 'Backup',
    Billing = 'Billing',
    Budget = 'Budget',
    Config = 'Config',
    Data = 'Data',
    Databases = 'Databases',
    Encryption = 'Encryption',
    End_Point_Protection = 'End Point Protection',
    Governance = 'Governance',
    High = 'High',
    Host = 'Host',
    Identity = 'Identity',
    Idle = 'Idle',
    Logging = 'Logging',
    Monitoring = 'Monitoring',
    Naming_Standards = 'Naming Standards',
    Network = 'Network',
    Operation = 'Operation',
    Optimized = 'Optimized',
    Orphaned = 'Orphaned',
    Performance = 'Performance',
    SNS = 'SNS',
    Security = 'Security',
    Standards = 'Standards',
    Storage = 'Storage',
    Tags = 'Tags',
    Underutilized = 'Underutilized',
    Utilization = 'Utilization',
    medium = 'medium'
}
